/**
 * Foi necessário realizar a alteração do index devido a uma correção de erro recomendada pelo
 * module federation.
 * https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
 */
import('./bootstrap');
